export var DeloitteProjectTypeApi;
(function (DeloitteProjectTypeApi) {
    DeloitteProjectTypeApi["CLIENT_BILLABLE"] = "client_billable";
    DeloitteProjectTypeApi["FIRM_INITIATIVE"] = "firm_initiative";
    DeloitteProjectTypeApi["PRD"] = "prd";
    DeloitteProjectTypeApi["OTHER_INVESTMENT"] = "other_investment";
    DeloitteProjectTypeApi["SKILLS_BASED_VOLUNTEERING"] = "skills_based_volunteering";
    DeloitteProjectTypeApi["INTERNAL_SERVICES"] = "internal_services";
    DeloitteProjectTypeApi["MARKETPLACE_OR_FIRM_CONTRIBUTION"] = "marketplace_or_firm_contribution";
})(DeloitteProjectTypeApi || (DeloitteProjectTypeApi = {}));
export var DeloitteContributionApi;
(function (DeloitteContributionApi) {
    DeloitteContributionApi["BUSINESS_DEVELOPMENT"] = "business_development";
    DeloitteContributionApi["MARKET_SUPPORT"] = "market_support";
    DeloitteContributionApi["RECRUITING_AND_MENTORSHIP"] = "recruiting_and_mentorship";
    DeloitteContributionApi["LD_DESIGN_AND_DELIVERY"] = "ld_design_and_delivery";
    DeloitteContributionApi["DEI_AND_WELLBEING"] = "dei_and_wellbeing";
    DeloitteContributionApi["NETWORK_OR_LOCAL_OFFICE"] = "network_or_local_office";
    DeloitteContributionApi["SKILLS_BASED_VOLUNTEERING"] = "skills_based_volunteering";
})(DeloitteContributionApi || (DeloitteContributionApi = {}));
export var DeloitteUtilizationApi;
(function (DeloitteUtilizationApi) {
    DeloitteUtilizationApi["UTILIZATION"] = "utilization";
    DeloitteUtilizationApi["ADJUSTED_UTILIZATION"] = "adjusted_utilization";
    DeloitteUtilizationApi["NO_UTILIZATION"] = "no_utilization";
})(DeloitteUtilizationApi || (DeloitteUtilizationApi = {}));
export var DeloitteBusinessLineApi;
(function (DeloitteBusinessLineApi) {
    DeloitteBusinessLineApi["AUDIT_AND_ASSURANCE"] = "audit_and_assurance";
    DeloitteBusinessLineApi["CONSULTING"] = "consulting";
    DeloitteBusinessLineApi["INTERNAL_SERVICES"] = "internal_services";
    DeloitteBusinessLineApi["RISK_AND_FINANCIAL_ADVISORY"] = "risk_and_financial_advisory";
    DeloitteBusinessLineApi["TAX"] = "tax";
    DeloitteBusinessLineApi["GPS_ENABLING_AREA"] = "gps_enabling_area";
    DeloitteBusinessLineApi["OTHER"] = "other";
})(DeloitteBusinessLineApi || (DeloitteBusinessLineApi = {}));
export var DeloittePracticeApi;
(function (DeloittePracticeApi) {
    DeloittePracticeApi["COMMERCIAL_CORE"] = "commercial_core";
    DeloittePracticeApi["COMMERCIAL_USDC_ONSITE"] = "commercial_usdc_onsite";
    DeloittePracticeApi["COMMERCIAL_USDC_INCENTER"] = "commercial_usdc_incenter";
    DeloittePracticeApi["GPS_CORE"] = "gps_core";
    DeloittePracticeApi["GPS_USDC_ONSITE"] = "gps_usdc_onsite";
    DeloittePracticeApi["GPS_USDC_INCENTER"] = "gps_usdc_incenter";
    DeloittePracticeApi["USI_ONSITE"] = "usi_onsite";
    DeloittePracticeApi["USI_OFFSHORE"] = "usi_offshore";
    DeloittePracticeApi["GPS_OPERATIONAL_EXCELLENCE"] = "gps_operational_excellence";
    DeloittePracticeApi["GPS_USI_OFFSHORE"] = "gps_usi_offshore";
    DeloittePracticeApi["GPS_USI_ONSITE"] = "gps_usi_onsite";
    DeloittePracticeApi["COMMERCIAL_ARDC"] = "commercial_ardc";
})(DeloittePracticeApi || (DeloittePracticeApi = {}));
export var DeloittePracticeGroupApi;
(function (DeloittePracticeGroupApi) {
    DeloittePracticeGroupApi["COMMERCIAL"] = "commercial";
    DeloittePracticeGroupApi["GOVERNMENT_AND_PUBLIC_SERVICES"] = "government_and_public_services";
    DeloittePracticeGroupApi["OTHER"] = "other";
})(DeloittePracticeGroupApi || (DeloittePracticeGroupApi = {}));
export var DeloitteIndustryApi;
(function (DeloitteIndustryApi) {
    DeloitteIndustryApi["AUTOMOTIVE"] = "automotive";
    DeloitteIndustryApi["BANKING_AND_CAPITAL_MARKETS"] = "banking_and_capital_markets";
    DeloitteIndustryApi["CIVIL_GOVERNMENT"] = "civil_government";
    DeloitteIndustryApi["CONSUMER_PRODUCTS"] = "consumer_products";
    DeloitteIndustryApi["CROSS_SECTOR_C"] = "cross_sector_c";
    DeloitteIndustryApi["CROSS_SECTOR_CI"] = "cross_sector_ci";
    DeloitteIndustryApi["CROSS_SECTOR_ERI"] = "cross_sector_eri";
    DeloitteIndustryApi["CROSS_SECTOR_FS"] = "cross_sector_fs";
    DeloitteIndustryApi["CROSS_SECTOR_GPS"] = "cross_sector_gps";
    DeloitteIndustryApi["CROSS_SECTOR_LSHC"] = "cross_sector_lshc";
    DeloitteIndustryApi["CROSS_SECTOR_TMT"] = "cross_sector_tmt";
    DeloitteIndustryApi["DEFENSE_SECURITY_AND_JUSTICE"] = "defense_security_and_justice";
    DeloitteIndustryApi["FEDERAL_HEALTH"] = "federal_health";
    DeloitteIndustryApi["HEALTH_CARE"] = "health_care";
    DeloitteIndustryApi["INDUSTRIAL_PRODUCTS_AND_CONSTRUCTION"] = "industrial_products_and_construction";
    DeloitteIndustryApi["INSURANCE"] = "insurance";
    DeloitteIndustryApi["INVESTMENT_MANAGEMENT"] = "investment_management";
    DeloitteIndustryApi["MEDIA_AND_ENTERTAINMENT"] = "media_and_entertainment";
    DeloitteIndustryApi["OIL_GAS_AND_CHEMICALS"] = "oil_gas_and_chemicals";
    DeloitteIndustryApi["POWER_AND_UTILITIES"] = "power_and_utilities";
    DeloitteIndustryApi["REAL_ESTATE"] = "real_estate";
    DeloitteIndustryApi["RETAIL_WHOLESALE_AND_DISTRIBUTION"] = "retail_wholesale_and_distribution";
    DeloitteIndustryApi["STATE_LOCAL_AND_HIGHER_EDUCATION"] = "state_local_and_higher_education";
    DeloitteIndustryApi["TECHNOLOGY"] = "technology";
    DeloitteIndustryApi["TRANSPORTATION_HOSPITALITY_AND_SERVICES"] = "transportation_hospitality_and_services";
    DeloitteIndustryApi["TELECOM_MEDIA_AND_ENTERTAINMENT"] = "telecom_media_and_entertainment";
    DeloitteIndustryApi["AUTOMOTIVE_TRANSPORTATION_HOSPITALITY_AND_SERVICES"] = "automotive_transportation_hospitality_and_services";
    DeloitteIndustryApi["INVESTMENT_MANAGEMENT_AND_REAL_ESTATE"] = "investment_management_and_real_estate";
    DeloitteIndustryApi["LIFE_SCIENCES"] = "life_sciences";
    DeloitteIndustryApi["RETAIL_AND_CONSUMER_PRODUCTS"] = "retail_and_consumer_products";
    DeloitteIndustryApi["NOT_APPLICABLE"] = "not_applicable";
    DeloitteIndustryApi["ENERGY_AND_CHEMICALS"] = "energy_and_chemicals";
    DeloitteIndustryApi["HOLDING_COMPANIES"] = "holding_companies";
    DeloitteIndustryApi["INDIVIDUALS_AND_ESTATES"] = "individuals_and_estates";
    DeloitteIndustryApi["INDUSTRY"] = "industry";
    DeloitteIndustryApi["POWER_UTILITIES_AND_RENEWABLES"] = "power_utilities_and_renewables";
    DeloitteIndustryApi["UNCLASSIFIED_INDUSTRIES"] = "unclassified_industries";
    DeloitteIndustryApi["NOT_ASSIGNED"] = "not_assigned";
})(DeloitteIndustryApi || (DeloitteIndustryApi = {}));
export var DeloitteIndustryGroupApi;
(function (DeloitteIndustryGroupApi) {
    DeloitteIndustryGroupApi["CONSUMER"] = "consumer";
    DeloitteIndustryGroupApi["ENERGY_RESOURCES_AND_INDUSTRIALS"] = "energy_resources_and_industrials";
    DeloitteIndustryGroupApi["FINANCIAL_SERVICES"] = "financial_services";
    DeloitteIndustryGroupApi["GOVERNMENT_AND_PUBLIC_SECTOR"] = "government_and_public_sector";
    DeloitteIndustryGroupApi["LIFE_SCIENCES_AND_HEALTH_CARE"] = "life_sciences_and_health_care";
    DeloitteIndustryGroupApi["TECHNOLOGY_MEDIA_AND_TELECOM"] = "technology_media_and_telecom";
    DeloitteIndustryGroupApi["INDUSTRY_NOT_APPLICABLE"] = "industry_not_applicable";
})(DeloitteIndustryGroupApi || (DeloitteIndustryGroupApi = {}));
export var DeloitteGigWorkerLevelApi;
(function (DeloitteGigWorkerLevelApi) {
    DeloitteGigWorkerLevelApi["ANALYST"] = "analyst";
    DeloitteGigWorkerLevelApi["CONSULTANT"] = "consultant";
    DeloitteGigWorkerLevelApi["SENIOR_CONSULTANT"] = "senior_consultant";
    DeloitteGigWorkerLevelApi["MANAGER"] = "manager";
    DeloitteGigWorkerLevelApi["SENIOR_MANAGER"] = "senior_manager";
    DeloitteGigWorkerLevelApi["PPMD"] = "ppmd";
})(DeloitteGigWorkerLevelApi || (DeloitteGigWorkerLevelApi = {}));
export const INDUSTRY_GROUPSApi = {
    [DeloitteIndustryApi.CROSS_SECTOR_C]: DeloitteIndustryGroupApi.CONSUMER,
    [DeloitteIndustryApi.AUTOMOTIVE_TRANSPORTATION_HOSPITALITY_AND_SERVICES]: DeloitteIndustryGroupApi.CONSUMER,
    [DeloitteIndustryApi.RETAIL_AND_CONSUMER_PRODUCTS]: DeloitteIndustryGroupApi.CONSUMER,
    [DeloitteIndustryApi.CROSS_SECTOR_TMT]: DeloitteIndustryGroupApi.TECHNOLOGY_MEDIA_AND_TELECOM,
    [DeloitteIndustryApi.TECHNOLOGY]: DeloitteIndustryGroupApi.TECHNOLOGY_MEDIA_AND_TELECOM,
    [DeloitteIndustryApi.TELECOM_MEDIA_AND_ENTERTAINMENT]: DeloitteIndustryGroupApi.TECHNOLOGY_MEDIA_AND_TELECOM,
    [DeloitteIndustryApi.CROSS_SECTOR_ERI]: DeloitteIndustryGroupApi.ENERGY_RESOURCES_AND_INDUSTRIALS,
    [DeloitteIndustryApi.INDUSTRIAL_PRODUCTS_AND_CONSTRUCTION]: DeloitteIndustryGroupApi.ENERGY_RESOURCES_AND_INDUSTRIALS,
    [DeloitteIndustryApi.OIL_GAS_AND_CHEMICALS]: DeloitteIndustryGroupApi.ENERGY_RESOURCES_AND_INDUSTRIALS,
    [DeloitteIndustryApi.POWER_AND_UTILITIES]: DeloitteIndustryGroupApi.ENERGY_RESOURCES_AND_INDUSTRIALS,
    [DeloitteIndustryApi.CROSS_SECTOR_FS]: DeloitteIndustryGroupApi.FINANCIAL_SERVICES,
    [DeloitteIndustryApi.BANKING_AND_CAPITAL_MARKETS]: DeloitteIndustryGroupApi.FINANCIAL_SERVICES,
    [DeloitteIndustryApi.INSURANCE]: DeloitteIndustryGroupApi.FINANCIAL_SERVICES,
    [DeloitteIndustryApi.INVESTMENT_MANAGEMENT_AND_REAL_ESTATE]: DeloitteIndustryGroupApi.FINANCIAL_SERVICES,
    [DeloitteIndustryApi.CROSS_SECTOR_GPS]: DeloitteIndustryGroupApi.GOVERNMENT_AND_PUBLIC_SECTOR,
    [DeloitteIndustryApi.CROSS_SECTOR_LSHC]: DeloitteIndustryGroupApi.LIFE_SCIENCES_AND_HEALTH_CARE,
    [DeloitteIndustryApi.HEALTH_CARE]: DeloitteIndustryGroupApi.LIFE_SCIENCES_AND_HEALTH_CARE,
    [DeloitteIndustryApi.LIFE_SCIENCES]: DeloitteIndustryGroupApi.LIFE_SCIENCES_AND_HEALTH_CARE,
    [DeloitteIndustryApi.NOT_APPLICABLE]: DeloitteIndustryGroupApi.INDUSTRY_NOT_APPLICABLE,
};
export var DeloitteOfferingApi;
(function (DeloitteOfferingApi) {
    DeloitteOfferingApi["CBO_CROSS_CONSULTING_GROUP"] = "cbo_cross_consulting_group";
    DeloitteOfferingApi["CBO_OPERATIONS_TRANSFORMATION"] = "cbo_operations_transformation";
    DeloitteOfferingApi["CBO_SYSTEMS_ENGINEERING"] = "cbo_systems_engineering";
    DeloitteOfferingApi["CBO_CLOUD_ENGINEERING"] = "cbo_cloud_engineering";
    DeloitteOfferingApi["CBO_CORE_INDUSTRY_SOLUTIONS"] = "cbo_core_industry_solutions";
    DeloitteOfferingApi["CBO_HEALTH_TECHNOLOGY"] = "cbo_health_technology";
    DeloitteOfferingApi["CNM_CUSTOMER_STRATEGY_AND_APPLIED_DESIGN"] = "cnm_customer_strategy_and_applied_design";
    DeloitteOfferingApi["CNM_ADVERTISING_MARKETING_AND_COMMERCE"] = "cnm_advertising_marketing_and_commerce";
    DeloitteOfferingApi["CNM_DIGITAL_CUSTOMER"] = "cnm_digital_customer";
    DeloitteOfferingApi["CNM_HUMAN_SERVICES_TRANSFORMATION"] = "cnm_human_services_transformation";
    DeloitteOfferingApi["CNM_CROSS_CONSULTING_GROUP"] = "cnm_cross_consulting_group";
    DeloitteOfferingApi["EO_CROSS_CONSULTING_GROUP"] = "eo_cross_consulting_group";
    DeloitteOfferingApi["EO_FINANCE_AND_ENTERPRISE_PERFORMANCE"] = "eo_finance_and_enterprise_performance";
    DeloitteOfferingApi["EO_SUPPLY_CHAIN_AND_NETWORK_OPERATIONS"] = "eo_supply_chain_and_network_operations";
    DeloitteOfferingApi["EO_TECHNOLOGY_SERVICES_OPTIMIZATION"] = "eo_technology_services_optimization";
    DeloitteOfferingApi["EO_SAP"] = "eo_sap";
    DeloitteOfferingApi["EO_ORACLE"] = "eo_oracle";
    DeloitteOfferingApi["EO_ERP_SAAS"] = "eo_erp_saas";
    DeloitteOfferingApi["HC_CROSS_CONSULTING_GROUP"] = "hc_cross_consulting_group";
    DeloitteOfferingApi["HC_HR_TRANSFORMATION"] = "hc_hr_transformation";
    DeloitteOfferingApi["HC_ORGANIZATION_TRANSFORMATION"] = "hc_organization_transformation";
    DeloitteOfferingApi["HC_WORKFORCE_TRANSFORMATION"] = "hc_workforce_transformation";
    DeloitteOfferingApi["HC_HC_AS_A_SERVICE"] = "hc_hc_as_a_service";
    DeloitteOfferingApi["MNA_MERGERS_AND_ACQUISITIONS"] = "mna_mergers_and_acquisitions";
    DeloitteOfferingApi["SNA_CROSS_CONSULTING_GROUP"] = "sna_cross_consulting_group";
    DeloitteOfferingApi["SNA_STRATEGY"] = "sna_strategy";
    DeloitteOfferingApi["SNA_ANALYTICS_AND_COGNITIVE"] = "sna_analytics_and_cognitive";
    DeloitteOfferingApi["SNA_HYBRID_SOLUTIONS_AND_INCUBATION"] = "sna_hybrid_solutions_and_incubation";
    DeloitteOfferingApi["NC_NATIONAL_CONSULTING"] = "nc_national_consulting";
    DeloitteOfferingApi["MNA_INTEGRATION_AND_DIVESTURE"] = "mna_integration_and_divesture";
    DeloitteOfferingApi["IS_GPS_BUSINESS_SYSTEMS"] = "is_gps_business_systems";
    DeloitteOfferingApi["IS_GPS_COMPLIANCE"] = "is_gps_compliance";
    DeloitteOfferingApi["IS_GPS_CONTRACTS"] = "is_gps_contracts";
    DeloitteOfferingApi["IS_GPS_FINANCE"] = "is_gps_finance";
    DeloitteOfferingApi["IS_GPS_SECURITY"] = "is_gps_security";
    DeloitteOfferingApi["CBO_OTHER"] = "cbo_other";
    DeloitteOfferingApi["CNM_ASSET_GROUP"] = "cnm_asset_group";
    DeloitteOfferingApi["CNM_OTHER"] = "cnm_other";
    DeloitteOfferingApi["EO_ASSET_GROUP"] = "eo_asset_group";
    DeloitteOfferingApi["EO_OTHER"] = "eo_other";
    DeloitteOfferingApi["HC_ASSET_GROUP"] = "hc_asset_group";
    DeloitteOfferingApi["HC_OTHER"] = "hc_other";
    DeloitteOfferingApi["MNA_OTHER"] = "mna_other";
    DeloitteOfferingApi["MNA_CCG"] = "mna_ccg";
    DeloitteOfferingApi["SNA_ASSET_GROUP"] = "sna_asset_group";
    DeloitteOfferingApi["SNA_OTHER"] = "sna_other";
    DeloitteOfferingApi["P_ORGANIC"] = "p_organic";
    DeloitteOfferingApi["P_SNET"] = "p_snet";
    DeloitteOfferingApi["NC_ADJUSTMENTS_OR_OTHER"] = "nc_adjustments_or_other";
    DeloitteOfferingApi["NC_ALLIANCES"] = "nc_alliances";
    DeloitteOfferingApi["NC_C_SUITE"] = "nc_c_suite";
    DeloitteOfferingApi["NC_CLIENT_AND_INDUSTRY"] = "nc_client_and_industry";
    DeloitteOfferingApi["NC_CLIENT_EXCELLENCE"] = "nc_client_excellence";
    DeloitteOfferingApi["NC_CLOUD"] = "nc_cloud";
    DeloitteOfferingApi["NC_CORPORATE_DEVELOPMENT"] = "nc_corporate_development";
    DeloitteOfferingApi["NC_DELIVERY_EXCELLENCE"] = "nc_delivery_excellence";
    DeloitteOfferingApi["NC_DTOC"] = "nc_dtoc";
    DeloitteOfferingApi["NC_INTERNATIONAL"] = "nc_international";
    DeloitteOfferingApi["NC_N_O_GLOBAL_CONSULTING_OFFICE"] = "nc_n_o_global_consulting_office";
    DeloitteOfferingApi["NC_OFFERING_PORTFOLIO"] = "nc_offering_portfolio";
    DeloitteOfferingApi["NC_OPERATION_AND_FINANCE"] = "nc_operation_and_finance";
    DeloitteOfferingApi["NC_OTHER_USI"] = "nc_other_usi";
    DeloitteOfferingApi["NC_PARTNER_MATTERS"] = "nc_partner_matters";
    DeloitteOfferingApi["NC_SALES_AND_PURSUIT_EXCELLENCE"] = "nc_sales_and_pursuit_excellence";
    DeloitteOfferingApi["NC_STRATEGY"] = "nc_strategy";
    DeloitteOfferingApi["NC_TALENT"] = "nc_talent";
    DeloitteOfferingApi["NC_TECH_AND_INNOVATION"] = "nc_tech_and_innovation";
    DeloitteOfferingApi["IS_GPS_BUSINESS_SERVICES"] = "is_gps_business_services";
    DeloitteOfferingApi["IS_GPS_OPS_MANAGEMENT"] = "is_gps_ops_management";
    DeloitteOfferingApi["IS_GPS_TALENT"] = "is_gps_talent";
    DeloitteOfferingApi["GPSEA_GPS_FINANCE"] = "gpsea_gps_finance";
    DeloitteOfferingApi["GPSEA_GPS_CONTRACTS"] = "gpsea_gps_contracts";
    DeloitteOfferingApi["GPSEA_GPS_CLIENT_EXCELLENCE"] = "gpsea_gps_client_excellence";
    DeloitteOfferingApi["GPSEA_GPS_TALENT"] = "gpsea_gps_talent";
    DeloitteOfferingApi["GPSEA_GPS_COMPLIANCE"] = "gpsea_gps_compliance";
    DeloitteOfferingApi["GPSEA_GPS_OPERATIONS"] = "gpsea_gps_operations";
    DeloitteOfferingApi["GPSEA_GPS_GENERAL_COUNSEL"] = "gpsea_gps_general_counsel";
    DeloitteOfferingApi["GPSEA_GPS_EA_MANAGEMENT"] = "gpsea_gps_ea_management";
    DeloitteOfferingApi["MARKETING_EXCELLENCE"] = "marketing_excellence";
})(DeloitteOfferingApi || (DeloitteOfferingApi = {}));
export var DeloitteOfferingPortfolioApi;
(function (DeloitteOfferingPortfolioApi) {
    DeloitteOfferingPortfolioApi["CORE_BUSINESS_OPERATIONS"] = "core_business_operations";
    DeloitteOfferingPortfolioApi["CUSTOMER_AND_MARKETING"] = "customer_and_marketing";
    DeloitteOfferingPortfolioApi["ENTERPRISE_OPERATIONS"] = "enterprise_operations";
    DeloitteOfferingPortfolioApi["HUMAN_CAPITAL"] = "human_capital";
    DeloitteOfferingPortfolioApi["MERGERS_AND_ACQUISITIONS"] = "mergers_and_acquisitions";
    DeloitteOfferingPortfolioApi["STRATEGY_AND_ANALYTICS"] = "strategy_and_analytics";
    DeloitteOfferingPortfolioApi["NATIONAL_CONSULTING"] = "national_consulting";
    DeloitteOfferingPortfolioApi["INTERNAL_SERVICES"] = "internal_services";
    DeloitteOfferingPortfolioApi["PLATFORMS"] = "platforms";
    DeloitteOfferingPortfolioApi["GPS_ENABLING_AREAS"] = "gps_enabling_areas";
    DeloitteOfferingPortfolioApi["CLIENT_AND_MARKET_GROWTH"] = "client_and_market_growth";
    DeloitteOfferingPortfolioApi["DC_HUMAN_CAPITAL"] = "dc_human_capital";
    DeloitteOfferingPortfolioApi["DC_TECHNOLOGY"] = "dc_technology";
    DeloitteOfferingPortfolioApi["NATIONAL_CONSULTING_MANAGEMENT"] = "national_consulting_management";
    DeloitteOfferingPortfolioApi["NBI"] = "nbi";
    DeloitteOfferingPortfolioApi["GPS_DC_MANAGEMENT"] = "gps_dc_management";
    DeloitteOfferingPortfolioApi["GPS_CMG"] = "gps_cmg";
    DeloitteOfferingPortfolioApi["GPS_COMPLIANCE"] = "gps_compliance";
    DeloitteOfferingPortfolioApi["GPS_CONTRACTS"] = "gps_contracts";
    DeloitteOfferingPortfolioApi["GPS_EA_MANAGEMENT"] = "gps_ea_management";
    DeloitteOfferingPortfolioApi["GPS_FINANCE"] = "gps_finance";
    DeloitteOfferingPortfolioApi["GPS_GENERAL_COUNSEL"] = "gps_general_counsel";
    DeloitteOfferingPortfolioApi["GPS_OPERATIONS"] = "gps_operations";
    DeloitteOfferingPortfolioApi["GPS_TALENT"] = "gps_talent";
    DeloitteOfferingPortfolioApi["NOT_APPLICABLE"] = "not_applicable";
})(DeloitteOfferingPortfolioApi || (DeloitteOfferingPortfolioApi = {}));
export const OFFERING_PORTFOLIOSApi = {
    [DeloitteOfferingApi.CBO_CROSS_CONSULTING_GROUP]: DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS,
    [DeloitteOfferingApi.CBO_OPERATIONS_TRANSFORMATION]: DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS,
    [DeloitteOfferingApi.CBO_SYSTEMS_ENGINEERING]: DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS,
    [DeloitteOfferingApi.CBO_CLOUD_ENGINEERING]: DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS,
    [DeloitteOfferingApi.CBO_CORE_INDUSTRY_SOLUTIONS]: DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS,
    [DeloitteOfferingApi.CBO_HEALTH_TECHNOLOGY]: DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS,
    [DeloitteOfferingApi.CNM_CUSTOMER_STRATEGY_AND_APPLIED_DESIGN]: DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING,
    [DeloitteOfferingApi.CNM_ADVERTISING_MARKETING_AND_COMMERCE]: DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING,
    [DeloitteOfferingApi.CNM_DIGITAL_CUSTOMER]: DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING,
    [DeloitteOfferingApi.CNM_HUMAN_SERVICES_TRANSFORMATION]: DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING,
    [DeloitteOfferingApi.CNM_CROSS_CONSULTING_GROUP]: DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING,
    [DeloitteOfferingApi.EO_CROSS_CONSULTING_GROUP]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.EO_FINANCE_AND_ENTERPRISE_PERFORMANCE]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.EO_SUPPLY_CHAIN_AND_NETWORK_OPERATIONS]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.EO_TECHNOLOGY_SERVICES_OPTIMIZATION]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.EO_SAP]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.EO_ORACLE]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.EO_ERP_SAAS]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.HC_CROSS_CONSULTING_GROUP]: DeloitteOfferingPortfolioApi.HUMAN_CAPITAL,
    [DeloitteOfferingApi.HC_HR_TRANSFORMATION]: DeloitteOfferingPortfolioApi.HUMAN_CAPITAL,
    [DeloitteOfferingApi.HC_ORGANIZATION_TRANSFORMATION]: DeloitteOfferingPortfolioApi.HUMAN_CAPITAL,
    [DeloitteOfferingApi.HC_WORKFORCE_TRANSFORMATION]: DeloitteOfferingPortfolioApi.HUMAN_CAPITAL,
    [DeloitteOfferingApi.HC_HC_AS_A_SERVICE]: DeloitteOfferingPortfolioApi.HUMAN_CAPITAL,
    [DeloitteOfferingApi.MNA_MERGERS_AND_ACQUISITIONS]: DeloitteOfferingPortfolioApi.MERGERS_AND_ACQUISITIONS,
    [DeloitteOfferingApi.MNA_INTEGRATION_AND_DIVESTURE]: DeloitteOfferingPortfolioApi.MERGERS_AND_ACQUISITIONS,
    [DeloitteOfferingApi.SNA_CROSS_CONSULTING_GROUP]: DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS,
    [DeloitteOfferingApi.SNA_STRATEGY]: DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS,
    [DeloitteOfferingApi.SNA_ANALYTICS_AND_COGNITIVE]: DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS,
    [DeloitteOfferingApi.SNA_HYBRID_SOLUTIONS_AND_INCUBATION]: DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS,
    [DeloitteOfferingApi.NC_NATIONAL_CONSULTING]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.IS_GPS_BUSINESS_SYSTEMS]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.IS_GPS_COMPLIANCE]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.IS_GPS_CONTRACTS]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.IS_GPS_FINANCE]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.IS_GPS_SECURITY]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.CBO_OTHER]: DeloitteOfferingPortfolioApi.CORE_BUSINESS_OPERATIONS,
    [DeloitteOfferingApi.CNM_ASSET_GROUP]: DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING,
    [DeloitteOfferingApi.CNM_OTHER]: DeloitteOfferingPortfolioApi.CUSTOMER_AND_MARKETING,
    [DeloitteOfferingApi.EO_ASSET_GROUP]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.EO_OTHER]: DeloitteOfferingPortfolioApi.ENTERPRISE_OPERATIONS,
    [DeloitteOfferingApi.HC_ASSET_GROUP]: DeloitteOfferingPortfolioApi.HUMAN_CAPITAL,
    [DeloitteOfferingApi.HC_OTHER]: DeloitteOfferingPortfolioApi.HUMAN_CAPITAL,
    [DeloitteOfferingApi.MNA_OTHER]: DeloitteOfferingPortfolioApi.MERGERS_AND_ACQUISITIONS,
    [DeloitteOfferingApi.MNA_CCG]: DeloitteOfferingPortfolioApi.MERGERS_AND_ACQUISITIONS,
    [DeloitteOfferingApi.SNA_ASSET_GROUP]: DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS,
    [DeloitteOfferingApi.SNA_OTHER]: DeloitteOfferingPortfolioApi.STRATEGY_AND_ANALYTICS,
    [DeloitteOfferingApi.P_ORGANIC]: DeloitteOfferingPortfolioApi.PLATFORMS,
    [DeloitteOfferingApi.P_SNET]: DeloitteOfferingPortfolioApi.PLATFORMS,
    [DeloitteOfferingApi.NC_ADJUSTMENTS_OR_OTHER]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_ALLIANCES]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_C_SUITE]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_CLIENT_AND_INDUSTRY]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_CLIENT_EXCELLENCE]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_CLOUD]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_CORPORATE_DEVELOPMENT]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_DELIVERY_EXCELLENCE]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_DTOC]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_INTERNATIONAL]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_N_O_GLOBAL_CONSULTING_OFFICE]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_OFFERING_PORTFOLIO]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_OPERATION_AND_FINANCE]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_OTHER_USI]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_PARTNER_MATTERS]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_SALES_AND_PURSUIT_EXCELLENCE]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_STRATEGY]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_TALENT]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.NC_TECH_AND_INNOVATION]: DeloitteOfferingPortfolioApi.NATIONAL_CONSULTING,
    [DeloitteOfferingApi.IS_GPS_BUSINESS_SERVICES]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.IS_GPS_OPS_MANAGEMENT]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.IS_GPS_TALENT]: DeloitteOfferingPortfolioApi.INTERNAL_SERVICES,
    [DeloitteOfferingApi.GPSEA_GPS_FINANCE]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.GPSEA_GPS_CONTRACTS]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.GPSEA_GPS_CLIENT_EXCELLENCE]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.GPSEA_GPS_TALENT]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.GPSEA_GPS_COMPLIANCE]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.GPSEA_GPS_OPERATIONS]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.GPSEA_GPS_GENERAL_COUNSEL]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.GPSEA_GPS_EA_MANAGEMENT]: DeloitteOfferingPortfolioApi.GPS_ENABLING_AREAS,
    [DeloitteOfferingApi.MARKETING_EXCELLENCE]: DeloitteOfferingPortfolioApi.CLIENT_AND_MARKET_GROWTH,
};
